(() => {
  if (globalThis.MFWeightEngine) return;
  const positive = x => Number.isFinite(x) && x > 0;
  function geometry(title) {
    const parts = String(title).split(' / ');
    const text = parts[0].split(/[•(]/)[0].trim();
    if (/\b(?:mm|cm|feet|ft)\b|\d\s*'|\d\s*\/\s*\d/i.test(text)) return null;
    const axes = {};
    for (const m of text.matchAll(/(\d+(?:\.\d+)?)\s*(?:inches|inch|in|["″”])?\s*(diameter|dia|L|W|H|D)\b/gi)) {
      const k = /^(dia|diameter)$/i.test(m[2]) ? 'D' : m[2].toUpperCase();
      if (axes[k]) return null;
      axes[k] = Number(m[1]);
    }
    if (!axes.H && parts.length > 1) {
      const h = parts[1].match(/^\s*(\d+(?:\.\d+)?)\s*["″”]?H\b/i);
      if (h) axes.H = Number(h[1]);
    }
    if (!axes.L && !axes.D) {
      const m = text.match(/^(\d+(?:\.\d+)?)\s*(?:in|["″”])?\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:in|["″”])?\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:in|["″”])?\s*H?$/i);
      if (m) [axes.L, axes.W, axes.H] = m.slice(1).map(Number);
    }
    const round = !!axes.D;
    const l = round ? axes.D : axes.L, w = round ? axes.D : axes.W, h = axes.H;
    if (![l,w,h].every(positive)) return null;
    let opening = 0, openingPerimeter = 0, openingWidth = 0;
    const match = String(title).match(/\(([^)]*Opening)\)/i);
    if (match) {
      const nums = [...match[1].matchAll(/\d+(?:\.\d+)?/g)].map(x => Number(x[0]));
      if (nums.length >= 2) { opening = nums[0]*nums[1]; openingPerimeter=2*(nums[0]+nums[1]); openingWidth=nums[1]; }
      else if (nums.length === 1) { const d=/D\b/i.test(match[1]); opening=d ? Math.PI*(nums[0]/2)**2 : nums[0]**2; openingPerimeter=(d ? Math.PI : 4)*nums[0]; openingWidth=nums[0]; }
    }
    return {l,w,h,round,opening,openingPerimeter,openingWidth,noOpening:/No Opening/i.test(title),area:round ? Math.PI*l*l/4 : l*w,perimeter:round ? Math.PI*l : 2*(l+w)};
  }
  function estimateProduct(g, profile, material) {
    if (!g || !profile || !profile.fabricated) return null;
    const aluminum = /aluminum/i.test(material), steel = /steel/i.test(material);
    if (!aluminum && !steel) return null;
    const density = aluminum ? .0975 : /stainless/i.test(material) ? .289 : .283;
    const gauge = aluminum ? .125 : .1046;
    let skin, frame, assembly, raw, frameInches=null, verticals=null;
    if (profile.method === 'sculpture') {
      if (!positive(profile.developedAreaSqIn) || !Number.isFinite(profile.sculptureFrameLb) || !Number.isFinite(profile.sculptureAssemblyLb)) return null;
      skin = profile.developedAreaSqIn;
      frame = profile.sculptureFrameLb;
      assembly = profile.sculptureAssemblyLb;
      raw = skin*gauge*density + frame + assembly;
    } else {
      skin = Math.max(0, (profile.openFrame ? 2 : 1)*g.area - g.opening) + g.perimeter*g.h*(profile.openFrame ? .35 : 1);
      if (profile.openFrame) return null;
      verticals = g.round ? Math.ceil(g.perimeter/12) : 2*Math.ceil(g.l/12)+2*Math.ceil(g.w/12);
      const tubeWidth=aluminum ? profile.aluminumTubeWidth : profile.steelTubeWidth, tubeDepth=aluminum ? profile.aluminumTubeDepth : profile.steelTubeDepth, tubeWall=profile.tubeWall;
      const verticalRun = verticals*Math.max(0,g.h-2*tubeDepth);
      const panSupport = g.noOpening ? 0 : g.openingPerimeter+2*Math.max(0,g.w-g.openingWidth);
      frameInches = 2*g.perimeter+verticalRun+panSupport;
      const tubeArea = tubeWidth*tubeDepth-(tubeWidth-2*tubeWall)*(tubeDepth-2*tubeWall);
      frame = frameInches*tubeArea*density;
      assembly = g.noOpening ? 0 : 15 + .008*g.opening;
      raw = skin*gauge*density*profile.shapeFactor+frame+assembly + (profile.hiddenTank ? 5 : 0);
    }
    const pounds = Math.max(5,Math.round(raw/5)*5);
    return {pounds,skinArea:skin,frameLb:frame,assemblyLb:assembly,gauge,density,frameInches,verticals,low:Math.floor(pounds*(profile.method==='sculpture' ? .5 : .65)/5)*5,high:Math.ceil(pounds*(profile.method==='sculpture' ? 2 : 1.6)/5)*5};
  }
  function shipment(g, productLb, sculpture = false) {
    if (!g || !positive(productLb)) return null;
    const l = Math.max(48,g.l+12), w = Math.max(42,g.w+4), h = g.h+12;
    const pallet = Math.round(50*l*w/(48*40)), packing = 25;
    return {l,w,h,product:Math.round(productLb),pallet,packing,gross:Math.round(productLb)+pallet+packing,packingReview:sculpture};
  }
  function resolveVariant(variant, profile) {
    const dimensions=geometry(variant.title);
    const estimate=estimateProduct(dimensions,profile,variant.title);
    const pounds=estimate ? estimate.pounds : Number(variant.grams)>0 ? Math.round(Number(variant.grams)/453.59237) : null;
    return {dimensions,estimate,pounds};
  }
  function profileFor(handle,tags=[]) {
    const base=globalThis.MFWeightProfiles && globalThis.MFWeightProfiles[handle];
    const methods={'mf-weight:linear':'linear','mf-weight:square-round':'planar','mf-weight:sculpture':'sculpture'};
    const assigned=[...new Set(tags.filter(t=>methods[t]).map(t=>methods[t]))];
    return base ? {...base,method:assigned.length===1 ? assigned[0] : base.method} : {fabricated:false,method:assigned.length===1 ? assigned[0] : 'catalog'};
  }
  globalThis.MFWeightEngine = Object.freeze({geometry,estimateProduct,shipment,resolveVariant,profileFor});
})();
